import React, { useState } from "react";
import PropTypes from "prop-types";
import "./IndividualAcademic.css";

const AcademicList = ({ title, items }) => {
  if (items.length === 0) return null;

  return (
    <div className="academic-list" data-testid={`academic-group-${title.toLowerCase()}`}>
      <p className="academic-list-title">{title}</p>
      <ul className="academic-list-items">
        {items.map((item, index) => (
          <li key={index} className="academic-list-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

AcademicList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const IndividualAcademic = ({
  institution,
  degree,
  from,
  to,
  certifications,
  achievements,
  activities,
  hackathons,
  animationDelay = 0,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const delayStyle = {
    animationDelay: `${animationDelay * 0.1}s`,
  };
  const summaryCounts = [
    { label: "certifications", count: certifications.length },
    { label: "achievements", count: achievements.length },
    { label: "activities", count: activities.length },
    { label: "hackathons", count: hackathons.length },
  ].filter((summary) => summary.count > 0);
  const headline = achievements[0] || certifications[0] || activities[0] || hackathons[0];

  return (
    <div className="academic-card" style={delayStyle}>
      <div className="academic-head">
        <div>
          <p className="academic-kicker">Academic profile</p>
          <h3 className="academic-institution">{institution}</h3>
          <p className="academic-degree">{degree}</p>
        </div>
        <p className="academic-duration">
          {from} - {to}
        </p>
      </div>

      {headline ? <p className="academic-highlight">{headline}</p> : null}

      <div className="academic-summary-grid" aria-label="Academic summary counts">
        {summaryCounts.map((summary) => (
          <div key={summary.label} className="academic-summary-pill">
            {summary.count} {summary.label}
          </div>
        ))}
      </div>

      <button
        type="button"
        className="academic-toggle"
        aria-expanded={showDetails ? "true" : "false"}
        aria-controls={`academic-details-${institution}`}
        onClick={() => setShowDetails((currentState) => !currentState)}
      >
        {showDetails ? "Hide details" : "Show details"}
      </button>

      <div
        id={`academic-details-${institution}`}
        data-testid="academic-details"
        className={`academic-details ${showDetails ? "academic-details-open" : ""}`}
      >
        <div className="academic-details-inner">
          <AcademicList items={certifications} title="Notable certifications" />
          <AcademicList items={achievements} title="Notable achievements" />
          <AcademicList items={activities} title="Academic activities" />
          <AcademicList items={hackathons} title="Hackathons" />
        </div>
      </div>
    </div>
  );
};

IndividualAcademic.propTypes = {
  institution: PropTypes.string.isRequired,
  degree: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  certifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  achievements: PropTypes.arrayOf(PropTypes.string).isRequired,
  activities: PropTypes.arrayOf(PropTypes.string).isRequired,
  hackathons: PropTypes.arrayOf(PropTypes.string).isRequired,
  animationDelay: PropTypes.number,
};

export default IndividualAcademic;
